package com.artvending.warden

import com.artvending.warden.screens.scanner.ScannerScreenModel
import com.artvending.warden.screens.success.SuccessScreenModel
import kotlinx.coroutines.delay

abstract class SendingQueue {
	protected suspend fun send(geolocation: Point?, qrCode: String): RequestAnswer {
		while (isSending)
			delay(500)
		
		isSending = true
		val result = sendScannerPostRequest(qrCode, geolocation)
		isSending = false
		
		if (result is Success) {
			val pickTime = pickTime!!
			val dayMinutes = pickTime.getDayMinutes()
			val oldFrom = fixedInterval?.from
			
			fixedInterval =
				if (oldFrom == null)
					TimeInterval(dayMinutes, null)
				else
					TimeInterval(oldFrom, dayMinutes)
			
			//currentScreenModel = SuccessScreenModel(pickTime)
			//return result
		}
		else {
//			showErrorAndWait(if (result is Failure) result.toString() else language.UNKNOWN_ERROR)
//			currentScreenModel = ScannerScreenModel()
			//return result
		}
		
		return result
	}
	
	
	abstract suspend fun fix(geolocation: Point, qrCode: String): RequestAnswer?
}